import { request } from "@umijs/max";
import { ApiResponse, PaginatedData, User, CreateUserRequest } from "@/types";

/** 用户下拉选项（仅需登录） GET /api/users/options */
export async function getUserOptions() {
  return request<ApiResponse<{ id: string; name: string; departmentId?: string; department?: { id: string; name: string } | null; avatar?: string; avatarColor?: string }[]>>("/api/users/options", {
    method: "GET",
  });
}

/** 用户列表 GET /api/users */
export async function getUsers(
  params: {
    current?: number;
    pageSize?: number;
    name?: string;
    departmentId?: string;
    roleId?: string;
    status?: string;
  },
  options?: { [key: string]: any },
) {
  return request<ApiResponse<PaginatedData<User>>>("/api/users", {
    method: "GET",
    params: {
      ...params,
      page: params.current,
    },
    ...(options || {}),
  });
}

/** 创建用户 POST /api/users */
export async function createUser(
  data: CreateUserRequest,
  options?: { [key: string]: any },
) {
  return request<ApiResponse<User>>("/api/users", {
    method: "POST",
    data,
    ...(options || {}),
  });
}

/** 更新用户 PUT /api/users/:id */
export async function updateUser(
  id: string,
  data: Partial<CreateUserRequest>,
  options?: { [key: string]: any },
) {
  return request<ApiResponse<User>>(`/api/users/${id}`, {
    method: "PUT",
    data,
    ...(options || {}),
  });
}

/** 重置用户密码 POST /api/users/:id/reset-password */
export async function resetUserPassword(
  id: string,
  options?: { [key: string]: any },
) {
  return request<ApiResponse<User>>(`/api/users/${id}/reset-password`, {
    method: "POST",
    ...(options || {}),
  });
}

/** 删除用户 DELETE /api/users/:id */
export async function deleteUser(id: string, options?: { [key: string]: any }) {
  return request<ApiResponse<null>>(`/api/users/${id}`, {
    method: "DELETE",
    ...(options || {}),
  });
}

/** 获取企业微信绑定链接 GET /api/wechat/bind-url */
export async function getWechatBindUrl(options?: { [key: string]: any }) {
  return request<{ url: string }>("/api/wechat/bind-url", { ...(options || {}) });
}

/** 解绑企业微信 POST /api/wechat/unbind */
export async function unbindWechat(options?: { [key: string]: any }) {
  return request<ApiResponse<{ message: string }>>("/api/wechat/unbind", {
    method: "POST",
    ...(options || {}),
  });
}

/** 测试推送企业微信消息 POST /api/wechat/test-send */
export async function testSendWechat(
  data: {
    userIds: string[];
    msgType: "text" | "textcard";
    content?: string;
    title?: string;
    description?: string;
    url?: string;
    btntxt?: string;
  },
  options?: { [key: string]: any },
) {
  return request<
    ApiResponse<{
      message: string;
      sentTo: { id: string; name: string }[];
      skipped: { id: string; name: string; reason: string }[];
      wechatResponse: Record<string, any>;
    }>
  >("/api/wechat/test-send", {
    method: "POST",
    data,
    ...(options || {}),
  });
}

/** 绑定企业微信回调 GET /api/wechat/bind-callback */
export async function bindWechatCallback(
  params: { code: string; state: string },
  options?: { [key: string]: any },
) {
  return request<{ success: boolean; message: string }>("/api/wechat/bind-callback", {
    method: "GET",
    params,
    ...(options || {}),
  });
}
